import i18nInstance, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import { adminLocaleNameSpaces, localeNameSpaces } from "./constants";
import { InitI18NextOptions } from "./server";

export const i18n = i18nInstance;

export function initI18NextBase({
  debug,
  defaultNS,
  fallbackLng,
  fallbackNS,
  lng,
  ns,
  resources,
  detection,
}: InitI18NextOptions<unknown>) {
  return i18n.use(initReactI18next).init({
    debug,
    defaultNS,
    detection,
    fallbackLng,
    fallbackNS,
    interpolation: {
      escapeValue: false,
    },
    keySeparator: ".",
    lng,
    ns,
    nsSeparator: ":",
    resources,
  });
}

export function initI18next(namespace: localeNameSpaces, resources: Resource) {
  const namespaceString = localeNameSpaces[namespace];
  return initI18NextBase({
    debug: process.env.NODE_ENV !== "production",
    defaultNS: namespaceString,
    fallbackLng: "fa",
    fallbackNS: namespaceString,
    lng: "fa",
    ns: [namespaceString],
    resources,
  });
}

export async function initAdminI18next(namespace: adminLocaleNameSpaces, resources: Resource) {
  const namespaceString = adminLocaleNameSpaces[namespace];
  return initI18NextBase({
    debug: process.env.NODE_ENV !== "production",
    defaultNS: namespaceString,
    fallbackLng: "fa",
    fallbackNS: namespaceString,
    lng: "fa",
    ns: [namespaceString],
    resources,
  });
}
